module.exports = __webpack_public_path__ + "img/bi.cad72512.svg";